import React from "react"

export function Report(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.75 0C0.783437 0 0 0.783437 0 1.75V14.25C0 15.2166 0.783437 16 1.75 16H12.25C13.2166 16 14 15.2166 14 14.25V4.75H9.625C8.93789 4.75 8.375 4.1875 8.375 3.5V0H1.75ZM9.625 0V3.5H14L9.625 0ZM3.0625 8.5H10.9375C11.2812 8.5 11.5625 8.78125 11.5625 9.125C11.5625 9.46875 11.2812 9.75 10.9375 9.75H3.0625C2.71875 9.75 2.4375 9.46875 2.4375 9.125C2.4375 8.78125 2.71875 8.5 3.0625 8.5ZM3.0625 11H10.9375C11.2812 11 11.5625 11.2812 11.5625 11.625C11.5625 11.9688 11.2812 12.25 10.9375 12.25H3.0625C2.71875 12.25 2.4375 11.9688 2.4375 11.625C2.4375 11.2812 2.71875 11 3.0625 11Z"
        fill="currentColor"
      />
    </svg>
  )
}
